// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","White":"#FFFFFF","Black":"#333D47","radioGroup":"G73fb08"};